// Footer.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
import whiteLogo from '../assets/white-logo.png';
import ConsultationModal from './ConsultationModal';

const Footer = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  return (
    <footer className="bg-[#202356] text-white">
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            
            {/* Brand Column */}
            <div>
              <div className="mb-6">
                <Link to="/" className="inline-block hover:opacity-80 transition">
                  <img src={whiteLogo} alt="Notapaths" className="h-8" />
                </Link>
              </div>
              <p className="text-gray-300 text-sm font-light leading-relaxed mb-6">
                Global Mobility Support for Study and Work Abroad
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-sm text-gray-300 font-light">
                  <Mail size={16} />
                  <a href="mailto:info@notapaths.com" className="hover:text-white transition-colors">
                    info@notapaths.com
                  </a>
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-300 font-light">
                  <Phone size={16} />
                  <a href="tel:07418622985" className="hover:text-white transition-colors">
                    07418 622985
                  </a>
                </div>
              </div>
            </div>

            {/* Who We Are Column */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">WHO WE ARE</h4>
              <ul className="space-y-2 text-sm text-gray-300 font-light">
                <li>
                  <Link to="/about" className="hover:text-white transition-colors">
                    About Notapaths
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-white transition-colors">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="hover:text-white transition-colors">
                    News & Blog
                  </Link>
                </li>
              </ul>
            </div>

            {/* Our Services Column */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">OUR SERVICES</h4>
              <ul className="space-y-2 text-sm text-gray-300 font-light">
                <li>
                  <Link to="/study-abroad" className="hover:text-white transition-colors">
                    Study Abroad Support
                  </Link>
                </li>
                <li>
                  <Link to="/work-abroad" className="hover:text-white transition-colors">
                    Work Abroad Opportunities
                  </Link>
                </li>
              </ul>
            </div>

            {/* Quick Links Column */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">QUICK LINKS</h4>
              <ul className="space-y-2 text-sm text-gray-300 font-light">
                <li>
                  <button 
                    onClick={() => setShowConsultationModal(true)}
                    className="hover:text-white transition-colors text-left"
                  >
                    Book a Consultation
                  </button>
                </li>
                <li>
                  <a href="https://app.notapaths.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                    Client Portal Login
                  </a>
                </li>
                <li>
                  <Link to="/pricing" className="hover:text-white transition-colors">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy" className="hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="hover:text-white transition-colors">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="border-t border-gray-600 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              {/* Disclaimer */}
              <div className="text-xs text-gray-400 font-light max-w-2xl">
                <p>© Notapaths 2026. All rights reserved.</p>
              </div>

              {/* Social Media */}
              <div className="flex items-center gap-4">
                <span className="text-xs text-gray-400 font-light mr-2">Follow us:</span>
                <a href="https://www.facebook.com/profile.php?id=61586889876456" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Facebook size={20} />
                </a>
                <a href="https://www.instagram.com/notapaths" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Instagram size={20} />
                </a>
                <a href="https://www.linkedin.com/company/notapaths" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal} 
        onClose={() => setShowConsultationModal(false)} 
        serviceType="study-abroad"
      />
    </footer>
  );
};

export default Footer;
